import { render, staticRenderFns } from "./relatePropertyDialog.vue?vue&type=template&id=88ecddc0&scoped=true"
import script from "./relatePropertyDialog.vue?vue&type=script&lang=js"
export * from "./relatePropertyDialog.vue?vue&type=script&lang=js"
import style0 from "./relatePropertyDialog.vue?vue&type=style&index=0&id=88ecddc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ecddc0",
  null
  
)

export default component.exports